import React from 'react';
import { Input, Button, PaperClip, Select } from 'components';
import { ServiceService, BankService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { WhiteImage } from 'assets/img';

interface Props {
	onClose?: any;
	item?: any;
	document_types?: any;
	phonecodes?: any;
	banks?: any;
}

class CreateBankAccount extends React.Component<Props> {

	state = {
		form: {
			number: '',
			type: Constants.BANK_ACCOUNT_TYPES.NATIONAL.toString(),
			document_type_id: this.props.document_types[0].id || '',
			phonecode_id: this.props.phonecodes[0].id || '',
			document: '',
			phone: '',
			email: '',
			bank_id: '',
			bank_name: ''
		}
	}

	async componentDidMount() {
		if (this.props.item) {
			this.setState({
				form: {
					...this.state.form,
					number: this.props.item?.number || '',
					type: this.props.item?.type || Constants.BANK_ACCOUNT_TYPES.NATIONAL.toString(),
					document_type_id: this.props.item?.document_type_id || this.props.document_types[0].id || '',
					phonecode_id: this.props.item?.phonecode_id || this.props.phonecodes[0].id || '',
					document: this.props.item?.document || '',
					phone: this.props.item?.phone || '',
					email: this.props.item?.email || '',
					bank_id: this.props.item?.bank_id || '',
					bank_name: this.props.item?.bank_name || ''
				},
				item: this.props.item
			});
		}
	}

	submit = async (e: any) => {
		e.preventDefault();
		if (this.props.item != null) {
			await BankService.admin.edit({
				bank_account_id: this.props.item?.id,
				...this.state.form
			});
			Globals.showSuccess("Se ha modificado la cuenta bancaria correctamente");
			this.props.onClose();
		}
		else {
			await BankService.admin.create({
				...this.state.form,
			});
			Globals.showSuccess("Se ha creado la cuenta bancaria correctamente");
			this.props.onClose();
		}
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}
	
	render() {
		return (
			<div id="modal-create-bank-account">
				<form onSubmit={ this.submit }>
					<h3>Registro de Cuentas Bancarias</h3>
					<div className="row">
						<div className="col-md-6">
							<Select
								label="Tipo de cuenta"
								name="type"
								onChange={ this.change }
								value={ this.state.form.type }
								options={ [
									{ value: Constants.BANK_ACCOUNT_TYPES.NATIONAL.toString(), label: 'Nacional' },
									{ value: Constants.BANK_ACCOUNT_TYPES.INTERNATIONAL.toString(), label: 'Internacional' },
								] } />
						</div>
						<div className="col-md-6">
							{
								this.state.form.type == Constants.BANK_ACCOUNT_TYPES.NATIONAL.toString() ? (
									<Select
										label="Banco"
										name="bank_id"
										onChange={ this.change }
										value={ this.state.form.bank_id }
										options={ this.props.banks.map((i: any) => {
											return {
												value: i.id,
												label: i.name
											}
										}) } />
								) : (
									<Input
										color="white"
										value={ this.state.form.bank_name }
										name="bank_name" 
										label="Banco"
										onChange={ this.change } />
								)
							}
						</div>
						<div className="col-md-6">
							<Input
								type="number"
								color="white"
								value={ this.state.form.number }
								name="number" 
								label="Número de cuenta"
								onChange={ this.change } />
						</div>
						{
							this.state.form.type == Constants.BANK_ACCOUNT_TYPES.NATIONAL.toString() && (
								<div className="col-md-6">
									<div className="container-select">
										<p className="label">Tipo de Documento</p>
										<div>
											<Select
												className="document_type"
												name="document_type_id"
												onChange={ this.change }
												value={ this.state.form.document_type_id }
												options={ this.props.document_types.map((i: any) => {
													return {
														value: i.id,
														label: i.name
													}
												}) } />
											<Input
												type="number"
												color="white"
												value={ this.state.form.document }
												name="document" 
												placeholder="Documento"
												onChange={ this.change } />
										</div>
									</div>
								</div>
							)
						}
						{
							this.state.form.type == Constants.BANK_ACCOUNT_TYPES.NATIONAL.toString() && (
								<div className="col-md-6">
									<div className="container-select">
										<p className="label">Teléfono</p>
										<div>
											<Select
												name="phonecode_id"
												onChange={ this.change }
												value={ this.state.form.phonecode_id }
												options={ this.props.phonecodes.map((i: any) => {
													return {
														value: i.id,
														label: i.name
													}
												}) } />
											<Input
												type="number"
												color="white"
												value={ this.state.form.phone }
												name="phone" 
												placeholder="Teléfono"
												onChange={ this.change } />
										</div>
									</div>
								</div>
							)
						}
						<div className="col-md-6">
							<Input
								color="white"
								value={ this.state.form.email }
								name="email" 
								label="Correo electrónico"
								onChange={ this.change } />
						</div>
					</div>
					<div className="row row-buttons">
						<div className="col-md-6 text-center">
							<Button type="button" onClick={ () => this.props.onClose() }>
								Cerrar
							</Button>
						</div>
						<div className="col-md-6 text-center">
							<Button type="submit">
								Guardar
							</Button>
						</div>
					</div>
				</form>
			</div>
		)
	}
}

export default CreateBankAccount;